/**
 * Labstep
 *
 * @module constants/organization-identifiers
 * @desc List of hardcoded organization identifiers
 */

export enum ORGANIZATION_IDENTIFIERS {
  djsantibodies = 'djsantibodies',
  labstep = 'labstep',
  ochrebio = 'ochrebio',
  miravista_diagnostics_llc = 'miravista_diagnostics_llc',
  university_of_edinburgh = 'university_of_edinburgh',
}
